import { createAction } from 'redux-actions';
import { SET_USER_NAME } from './actionTypes';

const setUserName = createAction(SET_USER_NAME);

// eslint-disable-next-line import/prefer-default-export
export { setUserName };
